import styled, { keyframes, css } from 'styled-components';
import PropTypes from 'prop-types';

const WaveAnimation = ({ carrierBillingPanel }) => {
  if (carrierBillingPanel) {
    return keyframes`
      0% {
        transform: rotateZ(0deg) translate3d(0, 3%, 0) rotateZ(0deg);
      }

      100% {
        transform: rotateZ(360deg) translate3d(0, 3%, 0) rotateZ(-360deg);
      }
    `;
  }

  return keyframes`
    0% {
      transform: rotateZ(0deg) translate3d(0, 5%, 0) rotateZ(0deg);
    }
    100% {
      transform: rotateZ(360deg) translate3d(0, 5%, 0) rotateZ(-360deg);
    }
  `;
};

const customHeight = ({ buying, carrierBillingPanel }) => {
  if (buying) {
    return css`
      height: 140px;
      margin-bottom: -240px;
      position: relative;
    `;
  }

  if (carrierBillingPanel) {
    return css`
      height: 80px;
      margin-bottom: 0px;
      position: fixed;
    `;
  }

  // default
  return css`
    height: 250px;
    margin-bottom: -240px;
    position: relative;
  `;
};

const WavesContainerStyled = styled.div`
  width: 100%;
  overflow: hidden;
  z-index: 0;
  ${customHeight}
`;

const FirstSceneLayerStyled = styled.div`
  height: 100%;
  svg {
    position: absolute;
    bottom: 40px;
    margin-left: -300px;
    width: 2500px;
    animation: ${WaveAnimation} 4s 0.1s infinite linear;
  }
`;

const SecondSceneLayerStyled = styled(FirstSceneLayerStyled)`
  svg {
    opacity: 0.6;
    margin-left: -150px;
    animation: ${WaveAnimation} 4.5s 0.3s infinite linear;
  }
`;

const ThridSceneLayerStyled = styled(SecondSceneLayerStyled)`
  svg {
    margin-left: -520px;
    animation: ${WaveAnimation} 5s 0.5s infinite linear;
  }
`;

WavesContainerStyled.propTypes = {
  buying: PropTypes.bool.isRequired,
};

export {
  WavesContainerStyled,
  FirstSceneLayerStyled,
  SecondSceneLayerStyled,
  ThridSceneLayerStyled,
};
